/**
 * Interpolates a template string with record field values.
 *
 * @example
 * interpolateTemplate("{codigo} - {nombre}", { codigo: "C001", nombre: "Acme" })
 * // Returns: "C001 - Acme"
 *
 * @param template - Template string with {fieldName} placeholders
 * @param record - Record object with field values
 * @returns Interpolated string with placeholders replaced by values
 */
export function interpolateTemplate<TRecord extends Record<string, unknown>>(
  template: string,
  record: TRecord
): string {
  return template.replace(/\{(\w+)\}/g, (_, fieldName) => {
    const value = record[fieldName]
    return value !== undefined && value !== null ? String(value) : ''
  })
}
